module.exports = __webpack_public_path__ + "static/areascreenshot-b3bb6369d26ef5e3520d577643b05a57.mp4";